import { render, staticRenderFns } from "./epidemicNews.vue?vue&type=template&id=36ff058a&scoped=true"
import script from "./epidemicNews.vue?vue&type=script&lang=js"
export * from "./epidemicNews.vue?vue&type=script&lang=js"
import style0 from "./epidemicNews.vue?vue&type=style&index=0&id=36ff058a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff058a",
  null
  
)

export default component.exports